'use client';

import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import NextLink from 'next/link';

const COOKIE_CONSENT_KEY = 'news-afrika-cookie-consent';

export default function CookieBanner() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasConsented = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!hasConsented) {
      setIsOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setIsOpen(false);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <Alert className="container mx-auto max-w-7xl flex flex-col sm:flex-row items-center justify-between gap-4 bg-card/95 backdrop-blur-sm border-primary/20 shadow-2xl">
        <div className="flex-1">
          <AlertTitle className="font-bold text-white">Our Use of Cookies</AlertTitle>
          <AlertDescription className="text-sm text-muted-foreground mt-1">
            We use cookies and other technologies to improve your experience, measure performance, and tailor marketing. See our <NextLink href="/privacy-policy" className="underline text-white hover:text-white/80 transition-colors">Privacy Policy</NextLink>.
          </AlertDescription>
        </div>
        <div className="flex gap-2 w-full sm:w-auto shrink-0">
          <Button onClick={handleAccept} className="flex-1 sm:flex-none bg-primary text-white hover:bg-primary/90 font-bold px-8">
            Ok, continue
          </Button>
        </div>
      </Alert>
    </div>
  );
}
